module.exports = __webpack_public_path__ + "media/images/advisor/img_7_2-3e673a63d63b10e449077fce031e23e2.png";